import { API_HOST } from "./config";

export const APIRoutes = {
  ADMIN_LOGIN: `${API_HOST}auth/admin-login`,
  ADMIN_FORGOT_PASSWORD: `${API_HOST}auth/forgot-password`,
  ADMIN_RESET_PASSWORD: `${API_HOST}auth/reset-password`,

  ADMIN: `${API_HOST}user`,

  SERVICES: `${API_HOST}services`,
  SERVICES_GET_ALL: `${API_HOST}services/get-all`,

  DASHBOARD_STATISTICS: `${API_HOST}dashboard/statistics`,
  DASHBOARD_YEARLY_STATISTICS: `${API_HOST}dashboard/yearly-statistics`,
  DASHBOARD_SERVICE_ANALYTICS: `${API_HOST}dashboard/service-analytics`,
  DASHBOARD_RECENT_REQUESTS: `${API_HOST}dashboard/recent-requests`,

  CITIES: `${API_HOST}cities`,

  USER: `${API_HOST}user`,
  USER_TOGGLE_BLOCK: `${API_HOST}user/toggle-block`,

  ORDERS: `${API_HOST}service-request`,
  CHANGE_ORDER_STATUS: `${API_HOST}service-request/change-status`,
  ONBOARDING: `${API_HOST}onboarding`,
  LANGUAGES: `${API_HOST}languages`,
  SUPPORT: `${API_HOST}support`,
};
